import styled from 'styled-components';
import { BP_TABLET_MAX } from '../../../../assets/styles/breakpoints';

export const CardSwitchSC = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;

  button {
    outline: none;
    border: none;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    background: transparent;
    height: 100%;
    padding: 1px 10px;

    &.active {
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 15px rgba(47, 46, 65, 0.15);
      border-radius: 7px;
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    button {
      width: 50%;
    }
  }
`;
